<template>
  <div>
    <page-header></page-header>
    <div class="heading-button-container">
      <h1 class="page-title">
        Multi Assign
        <span class="project-name">
          for session: {{ projects.name }}
        </span>
      </h1>
      <div class="button-column">
        <div class="button-group bottom-buttons">
          <!-- <button class="add-task-button" @click="openAddTasksModal()">Add a Task</button> -->
          <button class="back-button" @click="goBack">Back</button>
        </div>
      </div>
    </div>
    <div class="steps-container">
      <div class="artificial-fieldset-steps">
        <div class="legend-wrapper">
          <span class="artificial-fieldset-steps-legend">Step 1: Select Group of Trainees</span>
        </div>
        <div class="trainee-step-content">
          <button @click="openSelectGroupModal" class="add-task-button" :disabled="processing === true">
            {{ processing ? "Loading..." : "Select Group" }}
          </button>
          <div v-if="selectedTrainees.length" class="chip-container">
            <span v-for="trainee in selectedTrainees" :key="trainee.user_id" class="chip"
              :class="{ 'locked-chip': isTraineeLocked(trainee.user_id) }">
              <span v-if="isTraineeLocked(trainee.user_id)" class="lock-icon"
                title="This trainee's logbook has been locked">🔒</span>
              {{ trainee.first_name + ' ' + trainee.last_name }}
              <font-awesome-icon class="chip-close" :icon="['fas', 'times']"
                title="Remove trainee from the current selection" @click="removeTrainee(trainee)" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="artificial-fieldset-steps">
      <div class="legend-wrapper">
        <span class="artificial-fieldset-steps-legend">Step 2: Select Tasks</span>
      </div>
      <div class="flex-grow-1 d-flex justify-content-center" style="margin-bottom: 20px;">
        <div v-if="hasLockedTrainee" class="expired-box">
          Cannot assign tasks because one or more selected trainees have locked logbooks.
        </div>
      </div>
      <div class="heading-button-container" v-if="selectedTrainees.length">
        <div class="artificial-fieldset" style="margin-bottom: 20px;">
          <label class="artificial-fieldset-legend">Legend</label>
          <table class="help-info-table" style="text-align: left;">
            <tbody>
              <tr>
                <td style="padding-right: 40px; padding-left: 10px; padding-top: 10px;">
                  <div
                    style="display: inline-block; width: 13px; height: 13px; background-color: #c8f5c8; border: 1px solid grey; border-radius: 3px;">
                  </div>
                  - Task Assigned for all trainees
                </td>
                <td style="padding-top: 10px; padding-left: 20px;">
                  <div
                    style="display: inline-block; width: 13px; height: 13px; background-color: #fff3cd; border: 1px solid grey; border-radius: 3px;">
                  </div>
                  - Task Assigned for at least one trainee
                </td>
              </tr>
              <tr>
                <td style=" padding-top: 5px; padding-left: 10px;">
                  <input type="checkbox" disabled />
                  - Task is not Assigned for any trainees
                </td>
              </tr>
            </tbody>
          </table>
          <div class="color-filter" style="margin-top: 10px;">
            <label style="margin-right: 20px;">
              <input type="checkbox" v-model="colorFilters.allAssigned" />
              <span class="assigned-box">All Assigned</span>
            </label>

            <label style="margin-right: 20px;">
              <input type="checkbox" v-model="colorFilters.partiallyAssigned" />
              <span class="partially-assigned-box">Partially Assigned</span>
            </label>

            <label>
              <input type="checkbox" v-model="colorFilters.unassigned" />
              <span
                style="border: 1px solid #bbbbbb !important; padding: 2px 6px !important; border-radius: 3px;">Unassigned</span>
            </label>
          </div>
        </div>
        <div class="button-column">
          <div class="button-group bottom-buttons-multi">
            <!-- <button @click="toggleSelectAllTasks" class="multi-sign-off-button">
              {{ isAllTasksSelected ? 'Deselect All' : 'Select All' }}
            </button> -->
            <button @click="openChooseSignOffDateModal(null, 'multi')" class="multi-sign-off-button"
              :disabled="processing || hasLockedTrainee"
              :title="hasLockedTrainee ? 'Cannot assign tasks because one or more selected trainees have locked logbooks.' : ''">
              {{ processing ? 'Processing...' : 'Assign Selected' }}
            </button>
          </div>
        </div>
      </div>

      <div class="container-fluid-trainee" v-if="selectedTrainees.length">
        <vue-good-table :columns="columns" :rows="sortedFilteredTasks"
          :pagination-options="{ enabled: true, perPage: perPage }" :search-options="{ enabled: true }"
          :sort-options="{ enabled: true }" :row-style-class="rowStyleClass">
          <!-- Custom row rendering -->
          <template #table-row="props">

            <span v-if="props.column.field === 'description'">{{ props.row.description }}
              <!-- <font-awesome-icon icon="edit" class="edit-icon" @click="viewEditTask(task.task_id)"/> -->
              <font-awesome-icon v-if="isTaskEnabledInAnyLogbook(props.row.task_id)" class="show-trainees-icon"
                :icon="['fas', 'users']" @click="openEnabledTraineesModal(props.row)" title="Show assigned trainees" />
            </span>

            <span v-else-if="props.column.field === 'reference'" class="reference-cell">
              <template v-for="(part, index) in splitReference(props.formattedRow[props.column.field])" :key="index">
                {{ part }}<br v-if="index < splitReference(props.formattedRow[props.column.field]).length - 1" />
              </template>
            </span>

            <!-- P1 CHECKBOX -->
            <span v-else-if="props.column.field === 'entry_P1'">
              <input type="checkbox" v-model="props.row.entry_P1" :disabled="hasLockedTrainee"
                @change="handleP1P2Change(props.row, 'P1')" />
            </span>

            <!-- P2 CHECKBOX -->
            <span v-else-if="props.column.field === 'entry_P2'">
              <input type="checkbox" v-model="props.row.entry_P2" :disabled="hasLockedTrainee"
                @change="handleP1P2Change(props.row, 'P2')" />
            </span>

            <!-- UNASSIGN -->
            <span v-else-if="props.column.field === 'unassign'">
              <button
                class="icon-btn danger"
                @click="confirmUnassignSingle(props.row)"
                :disabled="processing || hasLockedTrainee || !isTaskEnabledInAnyLogbook(props.row.task_id)"
                title="Unassign task for all trainees in selected group"
                type="button"
              >
                <font-awesome-icon :icon="['fas', 'trash']" />
              </button>
            </span>

            <!-- DEFAULT -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>

          </template>
        </vue-good-table>
      </div>
      <div v-else class="no-trainees-message" style="margin-top: 1rem; font-style: italic; color: #888;">
        Please select a group of trainees to view and select tasks to assign.
      </div>
    </div>
    <edit-task-modal v-if="showEditTask" @close="closeEditTask"></edit-task-modal>
    <edit-task-reference-modal v-if="showEditTaskReference" @close="closeEditTaskReference"></edit-task-reference-modal>
    <add-tasks-modal v-if="showAddTasksModal" @close="closeAddTasksModal" />
    <view-enabled-trainees-modal v-if="showEnabledTraineesModal" :task="selectedTaskForTrainees"
      :trainees="selectedTaskForTrainees.trainees" @close="closeEnabledTraineesModal" />
    <select-group-modal v-if="showSelectGroupModal" :propTrainees="trainees" :projectId="projectId" :project="projects"
      :initialSelected="selectedTrainees" @confirm="handleTraineesSelected" @close="closeSelectGroupModal" />
    <ChooseSignOffDateModal v-if="showChooseSignOffDateModal" :task-id="currentTaskId"
      :logbookentryId="logbookentryId" :instructorId="instructorId" :signOffType="signOffType" @multiDateSelected="handleMultiSignOffDateSelected"
      @close="closeChooseSignOffDateModal"></ChooseSignOffDateModal>
    <MultiRevokeSignOffModal v-if="showMultiRevokeSignOffModal"
      :isInstSo="is_inst_so" :task="revokeTask" :entries="revokeEntries" :instructorId="instructorId"
      @submitted="handleRevokeSubmitted" @close="closeMultiRevokeSignOffModal">
    </MultiRevokeSignOffModal>
  </div>
</template>

<script>
import PageHeader from '../Examiner/Header.vue';
import EditTaskModal from './EditTaskDescriptionModal.vue';
import EditTaskReferenceModal from './EditTaskReferenceModal.vue';
import { VueGoodTable } from 'vue-good-table-next';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import axios from 'axios';
import AddTasksModal from './AddTasksModal.vue';
import ViewEnabledTraineesModal from './ViewEnabledTraineesModal.vue';
import SelectGroupModal from './SelectGroupModal.vue';
import ChooseSignOffDateModal from './ChooseSignOffDateModal.vue';
import MultiRevokeSignOffModal from '@/components/Instructor/MultiRevokeSignOffModal.vue';

export default {
  name: 'MultiEnable',
  data() {
    return {
      instructorId: parseInt(localStorage.getItem('user_id')),
      loggedInUser: '',
      logbooks: [],
      tasks: [],
      projects: [],
      traineeNames: [],
      entries: [],
      selectedTasks: [],
      modalTrainees: [],
      modalTasks: [],
      isAllTasksSelected: false,
      selectedTask: '',
      selectedProject: '',
      trainees: [],
      instructors: [],
      projectId: this.$route.params.projectId,
      filteredEntries: [],
      showEditTask: false,
      showEditTaskReference: false,
      processing: false,
      selectedMO: 'All',
      selectedCompleted: 'All tasks',
      selectedScope: 'All',
      selectedSkill: 'All',
      selectedChapter: 'All',
      acRegList: [],
      filteredACReg: [],
      acRegUpdateTimeout: null,
      showAddTasksModal: false,
      showSelectGroupModal: false,
      selectedTaskForTrainees: {},
      selectedTrainees: [],
      selectedTraineeIds: [],
      showEnabledTraineesModal: false,
      showChooseSignOffDateModal: false,
      selectedTraineesForEnable: [],
      showMultiRevokeSignOffModal: false,
      revokeTask: null,
      revokeEntries: [],
      revokePhase: null, // 'ins_so' | 'completed' | null
      pendingCompletedEntries: [],
      pendingTaskRow: null,
      pendingUnassignEntries: [],
      pendingTraineeIds: [],
      colorFilters: {
        allAssigned: true,
        partiallyAssigned: true,
        unassigned: true
      },
      perPage: 50,
      columns: [
        { label: 'ATA No', field: 'chapt_no', sortable: true, thClass: 'vgt-ata-column', tdClass: 'vgt-ata-column' },
        { label: 'Task No', field: 'task_no', sortable: true, thClass: 'vgt-task-no-column', tdClass: 'vgt-task-no-column' },
        { label: 'MT/AT', field: 'manob', sortable: true, thClass: 'vgt-manob-column', tdClass: 'vgt-manob-column' },
        { label: 'Scope', field: 'scope', sortable: true, thClass: 'vgt-task-no-column', tdClass: 'vgt-task-no-column' },
        { label: 'Description', field: 'description', sortable: true, thClass: 'vgt-description-column', tdClass: 'vgt-description-column' },
        { label: 'Reference', field: 'reference', sortable: true, thClass: 'vgt-reference-column', tdClass: 'vgt-reference-column' },
        { label: 'Category', field: 'category', sortable: true, thClass: 'vgt-category-column', tdClass: 'vgt-category-column' },
        { label: 'Classroom', field: 'entry_P1', sortable: false, thClass: 'vgt-actions-column', tdClass: 'vgt-actions-column' },
        { label: 'Aircraft', field: 'entry_P2', sortable: false, thClass: 'vgt-actions-column', tdClass: 'vgt-actions-column' },
        { label: 'Unassign', field: 'unassign', sortable: false, thClass: 'vgt-actions-column', tdClass: 'vgt-actions-column' },
      ],
    };
  },
  components: {
    PageHeader,
    VueGoodTable,
    EditTaskModal,
    EditTaskReferenceModal,
    AddTasksModal,
    ViewEnabledTraineesModal,
    SelectGroupModal,
    ChooseSignOffDateModal,
    MultiRevokeSignOffModal,
  },
  watch: {
    selectedChapter: 'resetSelectedTasks',
    selectedMO: 'resetSelectedTasks',
    selectedScope: 'resetSelectedTasks',
    selectedSkill: 'resetSelectedTasks',
    selectedCompleted: 'resetSelectedTasks',
  },
  computed: {
    filteredLogbooks() {
      if (!this.selectedTrainees.length) return [];
      const selectedIds = this.selectedTrainees.map(t => t.user_id);
      return this.logbooks.filter(logbook =>
        selectedIds.includes(logbook.trainee_id)
      );
    },
    filteredLogbookEntries() {
      if (!this.selectedTrainees.length) return [];
      return this.entries.filter(entry =>
        this.filteredLogbooks.some(logbook => logbook.logbook_id === entry.logbook_id)
      );
    },
    taskEnabledMap() {
      const map = {};
      this.filteredLogbookEntries.forEach(entry => {
        if (entry.enabled) {
          const key = `${entry.task_id}_${entry.logbook_id}`;
          map[key] = true;
        }
      });
      return map;
    },
    isTaskEnabledInAllLogbooks() {
      return (taskId) => {
        const selectedTraineeIds = this.selectedTrainees.map(t => t.user_id);
        const relevantLogbooks = this.filteredLogbooks.filter(logbook =>
          selectedTraineeIds.includes(logbook.trainee_id)
        );

        return relevantLogbooks.every(logbook =>
          this.taskEnabledMap[`${taskId}_${logbook.logbook_id}`]
        );
      };
    },
    isTaskEnabledInAnyLogbook() {
      return (taskId) => {
        const selectedTraineeIds = this.selectedTrainees.map(t => t.user_id);
        const relevantLogbooks = this.filteredLogbooks.filter(logbook =>
          selectedTraineeIds.includes(logbook.trainee_id)
        );

        return relevantLogbooks.some(logbook =>
          this.taskEnabledMap[`${taskId}_${logbook.logbook_id}`]
        );
      };
    },
    filteredTasks() {
      return this.tasks.filter(task => {
        const moMatches = this.selectedMO === 'All' || task.manob === this.selectedMO;
        const scopeMatches = this.selectedScope === 'All' || task.scope === this.selectedScope;
        const skillMatches = this.selectedSkill === 'All' || task.skill === this.selectedSkill;
        const chapterMatches = this.selectedChapter === 'All' || task.chapt_no === this.selectedChapter;

        // Determine assignment status
        const allAssigned = this.isTaskEnabledInAllLogbooks(task.task_id);
        const partiallyAssigned = !allAssigned && this.isTaskEnabledInAnyLogbook(task.task_id);
        const unassigned = !allAssigned && !partiallyAssigned;

        // Filter based on legend color selection
        const colorMatch =
          (this.colorFilters.allAssigned && allAssigned) ||
          (this.colorFilters.partiallyAssigned && partiallyAssigned) ||
          (this.colorFilters.unassigned && unassigned);

        return moMatches && scopeMatches && skillMatches && chapterMatches && colorMatch;
      });
    },
    sortedFilteredTasks() {
      const chapRegex = /^(\d+)([A-Za-z]*)$/;

      return this.filteredTasks.slice().sort((a, b) => {
        const [, numA, suffixA] = (a.chapt_no || '').match(chapRegex) || [];
        const [, numB, suffixB] = (b.chapt_no || '').match(chapRegex) || [];

        const chapterComparison = Number(numA) - Number(numB);
        if (chapterComparison !== 0) return chapterComparison;

        const suffixComparison = (suffixA || '').localeCompare(suffixB || '');
        if (suffixComparison !== 0) return suffixComparison;

        const taskA = parseInt(a.task_no, 10);
        const taskB = parseInt(b.task_no, 10);

        return taskA - taskB;
      });
    },
    uniqueChapters() {
      const chapters = this.tasks.map(task => task.chapt_no);
      return [...new Set(chapters)];
    },
    uniqueMOs() {
      const MOs = this.tasks.map(task => task.manob);
      return [...new Set(MOs)];
    },
    uniqueScopes() {
      const scopes = this.tasks.map(task => task.scope);
      return [...new Set(scopes)];
    },
    uniqueSkills() {
      const skills = this.tasks.map(task => task.skill);
      return [...new Set(skills)];
    },
    uniqueACRegList() {
      if (!this.entries) return [];
      const acRegList = this.entries
        .map(task => task.initial_ac_reg)
        .filter(initial_ac_reg => initial_ac_reg)
        .filter((initial_ac_reg, index, self) => self.indexOf(initial_ac_reg) === index);

      console.log('acRegList');
      console.log(acRegList);
      return acRegList;
    },
    isP1CheckedForAll() {
      return (taskId) => {
        const relevantEntries = this.filteredLogbookEntries.filter(e => e.task_id === taskId);
        return relevantEntries.length > 0 && relevantEntries.every(e => e.entry_P1 === true);
      };
    },
    isP1CheckedForAny() {
      return (taskId) => {
        const relevantEntries = this.filteredLogbookEntries.filter(e => e.task_id === taskId);
        return relevantEntries.some(e => e.entry_P1 === true);
      };
    },
    isP2CheckedForAll() {
      return (taskId) => {
        const relevantEntries = this.filteredLogbookEntries.filter(e => e.task_id === taskId);
        return relevantEntries.length > 0 && relevantEntries.every(e => e.entry_P2 === true);
      };
    },
    isP2CheckedForAny() {
      return (taskId) => {
        const relevantEntries = this.filteredLogbookEntries.filter(e => e.task_id === taskId);
        return relevantEntries.some(e => e.entry_P2 === true);
      };
    },
    isTraineeLocked() {
      return (traineeId) => {
        const logbook = this.logbooks.find(l => l.trainee_id === traineeId);
        return logbook ? logbook.locked === 1 : 0;
      };
    },
    hasLockedTrainee() {
      return this.selectedTrainees.some(t => this.isTraineeLocked(t.user_id));
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'InstructorHome' });
    },
    rowStyleClass(row) {
      if (this.isTaskEnabledInAllLogbooks(row.task_id)) {
        return 'enabled-task';
      }
      if (this.isTaskEnabledInAnyLogbook(row.task_id)) {
        return 'partially-enabled-task';
      }
      return '';
    },
    splitReference(value) {
      if (!value) return [''];
      return String(value).split('\\');
    },
    addFilters() {
      const addDropdownFilter = (field, items) => {
        const col = this.columns.find(c => c.field === field);
        if (!col) return;

        col.filterOptions = {
          enabled: true,
          placeholder: "All",
          filterDropdownItems: items,
          filterFn: (rowValue, filterValue) => {
            if (!filterValue) return true;
            return rowValue === filterValue;
          }
        };
      };

      addDropdownFilter("chapt_no", this.uniqueChapters);
      addDropdownFilter("manob", this.uniqueMOs);
      addDropdownFilter("scope", this.uniqueScopes);
      addDropdownFilter("skill", this.uniqueSkills);
    },
    toggleTaskCheckbox(taskId) {
      if (this.isTaskEnabledInAllLogbooks(taskId)) {
        return;
      }

      const index = this.selectedTasks.indexOf(taskId);
      if (index > -1) {
        this.selectedTasks.splice(index, 1);
      } else {
        this.selectedTasks.push(taskId);
      }
    },
    handleP1P2Change(task, changed) {
      // Ensure mutual exclusivity
      if (changed === 'P1' && task.entry_P1) task.entry_P2 = 0;
      if (changed === 'P2' && task.entry_P2) task.entry_P1 = 0;

      const realTask = this.tasks.find(t => t.task_id === task.task_id);
      if (realTask) {
        realTask.entry_P1 = task.entry_P1;
        realTask.entry_P2 = task.entry_P2;
      }

      // Update selectedTasks list
      const isSelected = task.entry_P1 || task.entry_P2;
      if (isSelected) {
        if (!this.selectedTasks.includes(task.task_id)) {
          this.selectedTasks.push(task.task_id);
        }
      } else {
        this.selectedTasks = this.selectedTasks.filter(id => id !== task.task_id);
      }
    },
    toggleP1(task) {
      task.entry_P1 = !task.entry_P1;
      this.handleP1P2Change(task, 'P1');
    },
    toggleP2(task) {
      task.entry_P2 = !task.entry_P2;
      this.handleP1P2Change(task, 'P2');
    },
    removeTrainee(trainee) {
      if (confirm('This will remove the trainee from the current selection. However, this will not delete the trainee from the group permanently.\n\nDo you want to continue?')) {
        this.selectedTrainees = this.selectedTrainees.filter(t => t.user_id !== trainee.user_id);

        const selectedIds = this.selectedTrainees.map(t => t.user_id);
        this.logbooks = this.logbooks.filter(logbook =>
          selectedIds.includes(logbook.trainee_id)
        );
        const logbookIds = this.logbooks.map(logbook => logbook.logbook_id);
        this.entries = this.entries.filter(entry =>
          logbookIds.includes(entry.logbook_id)
        );

        this.selectedTasks = [];
      }
    },
    getCommonACReg(taskId) {
      if (!this.selectedTrainees.length) return '';

      // Collect trainee IDs from the selected group
      const selectedTraineeIds = this.selectedTrainees.map(t => t.user_id);

      // Find logbooks for those trainees
      const selectedLogbookIds = this.logbooks
        .filter(lb => selectedTraineeIds.includes(lb.trainee_id))
        .map(lb => lb.logbook_id);

      // Filter entries only for the given task and selected trainees
      const relevantEntries = this.entries.filter(
        entry =>
          entry.task_id === taskId &&
          selectedLogbookIds.includes(entry.logbook_id)
      );

      if (relevantEntries.length === 0) return '';

      const first = relevantEntries[0].initial_ac_reg;

      const allSame = relevantEntries.every(
        entry => entry.initial_ac_reg === first
      );

      return allSame ? first : '';
    },
    async fetchData() {
      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        this.processing = true;
        const traineeResult = await axios.get('/api/users', { headers });
        const allTrainees = traineeResult.data.filter(user => Array.isArray(user.roles) && user.roles.includes('trainee'));
        const allInstructors = traineeResult.data.filter(user => Array.isArray(user.roles) && user.roles.includes('instructor'));

        const result = await axios.get(`/api/projects/${this.projectId}/logbooks`, { headers });
        this.logbooks = result.data;

        const projectResult = await axios.get(`/api/projects/${this.projectId}`, { headers });
        this.projects = projectResult.data.project;

        const taskResult = await axios.get(`/api/tasks/products/${this.projects.product_id}`, { headers });
        this.tasks = taskResult.data;

        const entryResult = await axios.get(`/api/logbookentry/projects/${this.projectId}`, { headers });
        this.entries = entryResult.data;
        console.log('entries', this.entries)

        const traineeIdsInLogbooks = this.logbooks.map(logbook => logbook.trainee_id);

        this.trainees = allTrainees.filter(user =>
          traineeIdsInLogbooks.includes(user.user_id)
        );
        this.instructors = allInstructors;

        this.filteredEntries = this.entries.filter(entry =>
          this.logbooks.some(logbook => logbook.logbook_id === entry.logbook_id)
        );

        // this.selectedTasks = this.tasks
        //   .filter(task => this.isTaskEnabledInAllLogbooks(task.task_id))
        //   .map(task => task.task_id);

        this.processing = false;
        this.addFilters();
      } catch (error) {
        console.error('Error fetching data:', error);
        this.processing = false;
      }
    },
    toggleSelectAllTasks() {
      if (this.isAllTasksSelected) {
        const notEnabledTaskIds = this.filteredTasks
          .filter(task => !this.isTaskEnabledInAllLogbooks(task.task_id))
          .map(task => task.task_id);

        this.selectedTasks = this.selectedTasks.filter(
          taskId => !notEnabledTaskIds.includes(taskId)
        );
      } else {
        const notEnabledTaskIds = this.filteredTasks
          .filter(task => !this.isTaskEnabledInAllLogbooks(task.task_id))
          .map(task => task.task_id);

        this.selectedTasks = Array.from(new Set([...this.selectedTasks, ...notEnabledTaskIds]));
      }

      this.isAllTasksSelected = !this.isAllTasksSelected;
    },
    async enableAll(selectedDate, traineeIdsSnapshot = null) {
      try {
        if (this.selectedTasks.length === 0) {
          alert('Please select at least one task.');
          return;
        }

        const traineeIds = traineeIdsSnapshot?.length
          ? traineeIdsSnapshot
          : this.selectedTrainees.map(t => t.user_id);

        if (!traineeIds.length) {
          alert('Please select at least one trainee.');
          return;
        }

        const normalizedDate =
          selectedDate
            ? new Date(selectedDate).toISOString().slice(0, 10)
            : null;

        this.processing = true;
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        const notYetEnabledTasks = this.selectedTasks.filter(
          taskId => !this.isTaskEnabledInAllLogbooks(taskId)
        );

        if (notYetEnabledTasks.length === 0) {
          alert('All selected tasks are already assigned for the selected trainees.');
          this.processing = false;
          return;
        }

        const logbookIds = this.logbooks
          .filter(logbook => traineeIds.includes(logbook.trainee_id))
          .map(logbook => logbook.logbook_id);

        const logbookEntries = [];
        logbookIds.forEach(logbook_id => {
          notYetEnabledTasks.forEach(task_id => {
            const existingEntry = this.entries.find(
              e => e.logbook_id === logbook_id && e.task_id === task_id
            );
            if (existingEntry && existingEntry.completed) return;

            const taskRow = this.sortedFilteredTasks.find(t => t.task_id === task_id);
            logbookEntries.push({
              logbook_id,
              task_id,
              enabled: true,
              ins_enabled_id: this.instructorId,
              selected_date: normalizedDate,
              ac_reg: null,
              entry_P1: !!taskRow?.entry_P1,
              entry_P2: !!taskRow?.entry_P2
            });
          });
        });

        if (logbookEntries.length > 2000) {
          alert('Too many tasks selected. Please reduce the number of selected tasks and try again.');
          this.processing = false;
          return;
        }

        const response = await axios.post(
          '/api/logbookentry/batch-update',
          { logbook_entries: logbookEntries },
          { headers }
        );

        if (response.status === 200) {
          alert('Tasks successfully assigned!');
          this.selectedTasks = [];
          this.isAllTasksSelected = false;
          this.fetchData();
        }
      } catch (error) {
        console.error('Error enabling tasks:', error);
        alert('An error occurred while assigning tasks.');
        this.processing = false;
      }
    },
    async unassignAll(taskIds, traineeIds, taskRow = null) {
      try {
        this.processing = true;

        const selectedLogbooks = this.logbooks.filter(lb => traineeIds.includes(lb.trainee_id));
        const logbookIds = selectedLogbooks.map(lb => lb.logbook_id);

        const matchingEntries = this.entries.filter(e =>
          logbookIds.includes(e.logbook_id) &&
          taskIds.includes(e.task_id) &&
          e.enabled
        );

        const entriesToUpdate = matchingEntries.filter(e => !e.completed && !e.ins_so);

        const logbookToTraineeId = selectedLogbooks.reduce((acc, lb) => {
          acc[lb.logbook_id] = lb.trainee_id;
          return acc;
        }, {});
        const traineeNameMap = this.trainees.reduce((acc, t) => {
          acc[t.user_id] = `${t.first_name} ${t.last_name}`;
          return acc;
        }, {});
        const instructorNameMap = this.instructors.reduce((acc, i) => {
          acc[i.user_id] = `${i.first_name} ${i.last_name}`;
          return acc;
        }, {});

        const traineeLinesFromEntries = (entries) => Array.from(new Set(
          entries.map(e => {
            const traineeId = logbookToTraineeId[e.logbook_id];
            return `• ${traineeNameMap[traineeId] || `Trainee ${traineeId}`}`;
          })
        ));

        const instructorLinesFromEntries = (entries) => Array.from(new Set(
          entries.map(e => {
            const traineeId = logbookToTraineeId[e.logbook_id];
            const traineeName = traineeNameMap[traineeId] || `Trainee ${traineeId}`;
            const instructorName = instructorNameMap[e.instructor_id] || `Instructor ${e.instructor_id}`;
            return `• ${traineeName} — signed off by ${instructorName}`;
          })
        ));

        const insSoEntries = matchingEntries.filter(e => e.ins_so);
        const completedEntries = matchingEntries.filter(e => e.completed);

        this.pendingUnassignEntries = matchingEntries;
        this.pendingTraineeIds = traineeIds;
        this.pendingCompletedEntries = completedEntries;
        this.pendingTaskRow = taskRow || this.tasks.find(t => t.task_id === taskIds[0]) || null;

        // STEP 1 of 2: revoke instructor sign-off
        if (insSoEntries.length) {
          const ok = confirm(
            `Step 1 of 2 — Revoke Instructor Sign-Off\n\n` +
            `One or more selected trainees have an instructor sign-off on this task:\n\n` +
            instructorLinesFromEntries(insSoEntries).join('\n') +
            `\n\nOpen instructor revoke screen now?`
          );
          if (!ok) { this.processing = false; return; }

          this.revokeTask = this.pendingTaskRow;
          this.revokeEntries = insSoEntries;
          this.is_inst_so = true;
          this.revokePhase = 'ins_so';
          this.showMultiRevokeSignOffModal = true;
          return;
        }

        // STEP 2 of 2: revoke trainee sign-off (reached directly if no ins_so present)
        if (completedEntries.length) {
          const ok = confirm(
            `Step 2 of 2 — Revoke Trainee Sign-Off\n\n` +
            `One or more selected trainees have this task completed (signed off):\n\n` +
            traineeLinesFromEntries(completedEntries).join('\n') +
            `\n\nOpen revoke screen now?`
          );
          if (!ok) { this.processing = false; return; }

          this.revokeTask = this.pendingTaskRow;
          this.revokeEntries = completedEntries;
          this.is_inst_so = false;
          this.revokePhase = 'completed';
          this.showMultiRevokeSignOffModal = true;
          return;
        }

        await this.doUnassignEntries(entriesToUpdate);
      } catch (err) {
        console.error(err);
        alert('An error occurred while unassigning tasks.');
      } finally {
        this.processing = false;
      }
    },
    async clearInstructorSignOffFlag(entries) {
      if (!entries || !entries.length) return;
      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        const payload = entries.map(e => ({
          logbook_id: e.logbook_id,
          task_id: e.task_id,
          ins_so: null,
          ins_signature_id: null,
        }));

        await axios.post('/api/logbookentry/batch-update', { logbook_entries: payload }, { headers });

        // Reflect locally too, so computed properties (isTaskEnabledInAnyLogbook,
        // row coloring, etc.) are correct immediately without waiting on a refetch.
        entries.forEach(e => {
          const local = this.entries.find(le => le.logbook_id === e.logbook_id && le.task_id === e.task_id);
          if (local) local.ins_so = null;
        });
      } catch (err) {
        console.error('Failed to clear instructor sign-off flag:', err);
        alert('Instructor sign-off revoke was recorded, but clearing the sign-off flag failed. Please refresh and check this task.');
      }
    },
    async doUnassignEntries(entriesToUnassign) {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      if (!entriesToUnassign.length) {
        alert('No eligible assigned tasks found to unassign.');
        return;
      }

      console.log('entries to unassign', entriesToUnassign);

      const payload = entriesToUnassign.map(e => ({
        logbook_id: e.logbook_id,
        task_id: e.task_id,
        enabled: 0,
        completed: null,
        ins_so: null,
        entry_P1: 0,
        entry_P2: 0,
        t_signature_id: null,
        ins_signature_id: null,
        selected_date: null,
        is_revoked: Boolean(e.completed),
      }));

      console.log('payload', payload);
      if (payload.length > 2000) {
        alert('Too many entries to unassign at once. Please reduce selection.');
        return;
      }

      const res = await axios.post(
        '/api/logbookentry/batch-update',
        { logbook_entries: payload },
        { headers }
      );

      if (res.status === 200) {
        alert('Tasks successfully unassigned!');
        this.selectedTasks = [];
        this.isAllTasksSelected = false;
        await this.fetchData();
      }
    },
    async confirmUnassignSingle(taskRow) {
      const traineesForTask = this.getTraineesForTask(taskRow.task_id); // may include non-selected
      const selectedIds = new Set(this.selectedTrainees.map(t => t.user_id));

      const trainees = traineesForTask.filter(t => selectedIds.has(t.user_id));
      const traineeIds = trainees.map(t => t.user_id);
      const ok = confirm(
        `This will unassign this task from ${traineeIds.length} trainee(s).\n\n` +
        `Continue?`
      );
      if (!ok) return;

      await this.unassignAll([taskRow.task_id], traineeIds, taskRow);
    },
    async handleRevokeSubmitted() {
      try {
        this.showMultiRevokeSignOffModal = false;

        // STEP 1 done: instructor sign-off just revoked
        if (this.revokePhase === 'ins_so') {
          // Clear ins_so on the entries that were just revoked, regardless of
          // whether the user proceeds to step 2 or cancels here.
          await this.clearInstructorSignOffFlag(this.revokeEntries);

          const completedEntries = this.pendingCompletedEntries || [];

          if (completedEntries.length) {
            const proceed = confirm(
              `Instructor sign-off has been revoked.\n\n` +
              `Step 2 of 2 — Revoke Trainee Sign-Off\n\n` +
              `These trainee(s) still have this task marked completed and must be revoked before it can be unassigned. Continue now?\n\n` +
              `(Cancel will stop here — the instructor sign-off stays revoked, but the task will NOT be unassigned.)`
            );

            if (!proceed) {
              alert('Instructor sign-off was revoked. Trainee sign-off was not revoked, so the task was not unassigned.');
              await this.fetchData();
              this.clearRevokeFlowState();
              return;
            }

            this.revokeTask = this.pendingTaskRow;
            this.revokeEntries = [...completedEntries];
            this.is_inst_so = false;
            this.revokePhase = 'completed';

            this.$nextTick(() => {
              this.showMultiRevokeSignOffModal = true;
            });
            return;
          }

          // No trainee revoke needed — safe to unassign directly
          const enabledEntries = (this.pendingUnassignEntries || []).filter(e => e.enabled);
          this.processing = true;
          await this.doUnassignEntries(enabledEntries);
          this.clearRevokeFlowState();
          return;
        }

        // STEP 2 done: trainee sign-off revoked — safe to unassign
        if (this.revokePhase === 'completed') {
          const enabledEntries = (this.pendingUnassignEntries || []).filter(e => e.enabled);
          this.processing = true;
          await this.doUnassignEntries(enabledEntries);
          this.clearRevokeFlowState();
          return;
        }
      } catch (e) {
        console.error(e);
        alert('Revokes were submitted, but unassign failed.');
      } finally {
        this.processing = false;
      }
    },
    closeMultiRevokeSignOffModal() {
      this.showMultiRevokeSignOffModal = false;

      // If they close out after step 1 (instructor sign-off) succeeded,
      // but before doing step 2 (trainee sign-off), let them know the
      // unassign did NOT go through.
      if (this.revokePhase === 'completed' && this.pendingTaskRow) {
        alert(
          'Instructor sign-off was revoked, but trainee sign-off was not. ' +
          'The task was NOT unassigned.'
        );
      }

      this.revokeTask = null;
      this.revokeEntries = [];
      this.fetchData(); // refresh in case step 1 already committed a revoke
      this.clearRevokeFlowState();
    },
    clearRevokeFlowState() {
      this.revokeTask = null;
      this.revokeEntries = [];
      this.pendingUnassignEntries = [];
      this.pendingTraineeIds = [];
      this.pendingCompletedEntries = [];
      this.pendingTaskRow = null;
      this.revokePhase = null;
    },
    handleACRegChange(event, task) {
      const newValue = event.target.value;
      task.initial_ac_reg = newValue;
      clearTimeout(this.acRegUpdateTimeout);

      this.acRegUpdateTimeout = setTimeout(() => {
        this.updateTaskACReg(task);
      }, 2000);
    },
    async updateTaskACReg(task) {
      try {
        this.processing = true;
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        const selectedTraineeIds = this.selectedTrainees.map(t => t.user_id);

        const logbookIds = this.logbooks
          .filter(logbook => selectedTraineeIds.includes(logbook.trainee_id))
          .map(logbook => logbook.logbook_id);

        const logbookEntries = logbookIds.map(logbook_id => ({
          logbook_id,
          task_id: task.task_id,
          initial_ac_reg: task.initial_ac_reg,
        }));

        const response = await axios.post('/api/logbookentry/batch-update',
          { logbook_entries: logbookEntries },
          { headers }
        );

        if (response.status === 200) {
          alert('AC Reg successfully updated for selected trainees!');

          this.entries.forEach(entry => {
            if (entry.task_id === task.task_id && logbookIds.includes(entry.logbook_id)) {
              entry.initial_ac_reg = task.initial_ac_reg;
            }
          });

          console.log('Updated local entries:', this.entries);
        }
      } catch (error) {
        console.error('Error updating AC Reg:', error);
        alert('An error occurred while updating AC Reg.');
      } finally {
        this.processing = false;
      }
    },
    viewEditTask(task_id) {
      localStorage.setItem('task_id', task_id);
      this.showEditTask = true;
    },
    closeEditTask() {
      this.showEditTask = false;
      this.fetchData();
    },
    viewEditTaskReference(task_id) {
      localStorage.setItem('task_id', task_id);
      this.showEditTaskReference = true;
    },
    closeEditTaskReference() {
      this.showEditTaskReference = false;
      this.fetchData();
    },
    openAddTasksModal() {
      this.showAddTasksModal = true;
    },
    closeAddTasksModal() {
      this.showAddTasksModal = false;
      this.fetchData();
    },
    closeEnabledTraineesModal() {
      this.showEnabledTraineesModal = false;
    },
    openEnabledTraineesModal(task) {
      const matchedTrainees = this.getTraineesForTask(task.task_id);

      this.selectedTaskForTrainees = {
        ...task,
        trainees: matchedTrainees
      };

      this.showEnabledTraineesModal = true;
    },
    openChooseSignOffDateModal(task, type) {
      this.signOffType = type;

      const notYetEnabledTasks = this.selectedTasks.filter(
        taskId => !this.isTaskEnabledInAllLogbooks(taskId)
      );

      if (notYetEnabledTasks.length === 0) {
        alert('All selected tasks are already assigned for the selected trainees.');
        this.processing = false;
        return;
      }

      if (type === 'multi') {
        // Multi sign-off mode (no specific task)
        this.selectedTraineesForEnable = this.selectedTrainees.map(t => t.user_id);
        this.currentTask = null;
        this.currentTaskId = null;
        this.logbookentryId = null;
      } else {
        // Single task sign-off
        this.currentTask = task;
        this.currentTaskId = task.task_id;
        this.logbookentryId = task.logbookentry_id;
      }

      this.showChooseSignOffDateModal = true;
    },
    closeChooseSignOffDateModal() {
      this.showChooseSignOffDateModal = false;
      this.selectedTraineesForEnable = [];
    },
    async handleMultiSignOffDateSelected(selectedDate) {
      const dateObj = this.formatDate(selectedDate);
      await this.enableAll(dateObj, this.selectedTraineesForEnable);
      this.showChooseSignOffDateModal = false;
    },
    formatDate(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    getTraineesForTask(taskId) {
      if (!this.entries.length || !this.logbooks.length || !this.trainees.length) {
        return [];
      }

      const selectedTraineeIds = this.selectedTrainees.map(t => t.user_id);

      const logbookMap = this.logbooks.reduce((map, logbook) => {
        map[logbook.logbook_id] = logbook.trainee_id;
        return map;
      }, {});

      const matchingEntries = this.entries.filter(entry => {
        const traineeId = logbookMap[entry.logbook_id];

        return (
          entry.task_id === taskId &&
          entry.enabled &&
          selectedTraineeIds.includes(traineeId)
        );
      });

      return matchingEntries
        .map(entry => {
          const traineeId = logbookMap[entry.logbook_id];
          const trainee = this.trainees.find(t => t.user_id === traineeId);

          if (!trainee) return null;

          return {
            ...trainee,
            entry: { ...entry }
          };
        })
        .filter(Boolean);
    },
    resetSelectedTasks() {
      this.selectedTasks = this.filteredTasks
        .filter(task => this.isTaskEnabledInAllLogbooks(task.task_id))
        .map(task => task.task_id);

      this.isAllTasksSelected = false;
    },
    openSelectGroupModal() {
      this.showSelectGroupModal = true;
    },
    closeSelectGroupModal() {
      this.showSelectGroupModal = false;
      this.fetchData();
    },
    handleTraineesSelected(selectedTrainees) {
      this.selectedTrainees = selectedTrainees;
      // Wait for Vue to update reactive dependencies before recalculating tasks
      // this.$nextTick(() => {
      //   this.updateSelectedTasks();
      // });
    },
    // updateSelectedTasks() {
    //   // Only select tasks after logbooks and entries have stabilized
    //   this.selectedTasks = this.tasks
    //     .filter(task => this.isTaskEnabledInAllLogbooks(task.task_id))
    //     .map(task => task.task_id);
    // }
  },
  async mounted() {
    this.fetchData();
    localStorage.setItem('projectId', this.projectId);
  },
}
</script>

<style scoped>
.select-project-container {
  float: left;
  /* Adjust this margin as needed */
  margin-left: 50px;
}

.select-project-container select {
  max-width: 250px;
}

span {
  border: 0px;
}

.container-fluid-trainee {
  padding-top: 10px;
  margin-left: 1%;
  margin-right: 1.5%;
}

h2 {
  font-size: 1.3rem;
  margin-bottom: 25px;
}

h1 {
  font-size: 2rem;
  margin-top: 10px;
  margin-bottom: 20px;
  padding-top: 0px;
  margin-left: 30px;
}

.completed-task {
  background-color: #a2f5a1;
  /* or any other color you want for completed tasks */
}

.signoff-buttons {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}

.select-task-container {
  float: left;
  /* Adjust this margin as needed */
  margin-left: 50px;
}

.select-task-container select {
  max-width: 250px;
}

.enabled-task {
  background-color: #c8f5c8 !important;
}

.partially-enabled-task {
  background-color: #fff3cd !important;
}

.edit-icon {
  font-size: 16px;
  color: #615f5f;
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
  float: right;
  margin-right: 10px;
}

.edit-icon:hover {
  color: #2b2a2a;
  cursor: pointer;
  transform: scale(1.1);

}

.back-button {
  /* Adjust the right position as needed */
  width: 100px;
  height: 30px;
  border-radius: 5px;
  background-color: #c1e0bf;
  font-size: 14px;
  border: 2px solid black;
  padding: 3px;
  margin-right: 20px;
}

.back-button:hover {
  background-color: #abc7a9;
  cursor: pointer;
}

.ac-reg-container {
  position: relative;
}

.ac-reg-suggestions {
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  max-height: 150px;
  overflow-y: auto;
  width: 100%;
  list-style-type: none;
  padding: 0;
  margin: 0;
  z-index: 1000;
}

.ac-reg-suggestions li {
  padding: 8px;
  cursor: pointer;
}

.ac-reg-suggestions li:hover {
  background-color: #f0f0f0;
}

.add-task-button {
  border-radius: 5px;
  min-width: 170px;
  height: 30px;
  background-color: #463333;
  color: white;
  border: 1px solid #200d0d;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 0 10px;
  margin-left: 15px;
  margin-right: 15px;
  display: inline-block;
}

.add-task-button:hover {
  background-color: #2b1616;
  color: white;
  transform: scale(1.05);
  transition: 0.3s;
}

.add-task-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.heading-button-container {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.button-group {
  display: flex;
  gap: 10px;
  /* space between buttons */
}

.show-trainees-icon {
  margin-left: 10px;
  color: #007bff;
  cursor: pointer;
}

.show-trainees-icon:hover {
  color: #0056b3;
}

.artificial-fieldset {
  margin-left: 30px;
  /* Adjust margin as needed */
  width: auto;
  /* Adjust the width as necessary */
}

.artificial-fieldset {
  border: 1px solid #757575;
  border-radius: 3px;
  padding: 10px;
  margin-top: 10px;
  margin-left: 10px;
  position: relative;
}

.artificial-fieldset-legend {
  position: absolute;
  top: -10px;
  left: 10px;
  background-color: #757575;
  color: white;
  border-radius: 5px;
  padding: 0 10px;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
}

.button-column {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.button-group {
  display: flex;
  gap: 10px;
}

.bottom-buttons {
  margin-top: 20px;
}

.bottom-buttons-multi {
  margin-top: 100px;
}


.data-table-trainee {
  width: 100%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-collapse: collapse;
  margin-top: 0;
  align-items: left;
  margin-bottom: 30px;
}

.disabled-checkbox {
  cursor: not-allowed;
}

.trainee-step-content {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.chip-container {
  margin-top: 10px;
}

.chip {
  display: inline-block;
  padding: 5px 10px;
  margin: 5px;
  background-color: #e0f3ff;
  border-radius: 20px;
  font-size: 14px;
  position: relative;
}

.chip-close {
  margin-left: 8px;
  cursor: pointer;
  color: #888;
}

.locked-chip {
  background-color: #ffd0d0 !important;
  border: 1px solid #ff6e6e !important;
  color: #a30000 !important;
}

.lock-icon {
  margin-right: 6px;
  font-size: 14px;
}

.artificial-fieldset-steps {
  border: 1px solid #8b8b8b;
  padding: 20px 10px 10px 10px;
  margin: 20px;
  margin-bottom: 30px;
  border-radius: 2px;
}

.legend-wrapper {
  float: left;
  margin-top: -32px;
  /* Vertically overlap the border */
  margin-left: 10px;
  /* Align with the fieldset's left padding */
  background-color: #e4e4e4;
  /* Ensure background matches container */
  border: 1px solid #8b8b8b;
  border-radius: 3px;
}

.artificial-fieldset-steps-legend {
  font-size: 14px;
  font-weight: bold;
  padding: 2px 8px;
}

.color-filter label {
  cursor: pointer;
  user-select: none;
}

.color-filter input {
  margin-right: 5px;
}

.assigned-box {
  background-color: #c8f5c8 !important;
  border: 1px solid #a4cfa4 !important;
  padding: 2px 6px !important;
  border-radius: 3px;
}

.partially-assigned-box {
  background-color: #fff3cd !important;
  border: 1px solid #ecdba1 !important;
  padding: 2px 6px !important;
  border-radius: 3px;
}

.multi-sign-off-button:disabled {
  cursor: not-allowed;
}

.icon-btn {
  border: none;
  background: transparent;
  padding: 4px 8px;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
}

.icon-btn.danger {
  color: #db2510;
}

.icon-btn.danger:hover {
  color: #a72213;
  transform: scale(1.1);
  transition: 0.2s;
}

.icon-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.page-title {
  text-align: left;
}

.project-name {
  /* display: block; */
  font-size: 20px !important;
  color: #7e828c;
}

.project-name:hover {
  color: #70747c !important;
}

.vgt-reference-column {
  white-space: normal !important;
  vertical-align: top;
}

.reference-cell {
  display: inline-block;
  line-height: 1.4;
}
</style>